import React from 'react'
import { Box, Typography } from '@mui/material'
import { advancedColors, onDark } from '../theme'

type Props = {
  title: string
  description?: string
  tone?: 'light' | 'dark'
  action?: React.ReactNode
}

const TONE_COLORS = {
  light: { title: advancedColors.inkMuted, description: advancedColors.inkFaint },
  dark: { title: onDark.primary, description: onDark.secondary },
} as const

const EmptyState = ({ title, description, tone = 'light', action }: Props) => {
  const colors = TONE_COLORS[tone]

  return (
    <Box sx={{ py: 3, textAlign: 'center' }}>
      <Typography variant="h5" sx={{ color: colors.title }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="subtitle1" sx={{ mt: 0.5, color: colors.description }}>
          {description}
        </Typography>
      )}
      {action}
    </Box>
  )
}

export default EmptyState
